import React from "react";
import { useSearchParams } from "react-router-dom";
import LayoutStyles from "../../../../toolkit/baseStyles/index";
import OnboardingCustomationLayout from "../../../components/charitySetup/onboarding/onboardingCustomation";
import ProtectedRoute from "../../../../Auth/components/ProtectedRoute";
import OnboardingAccessGate from "../../../components/charitySetup/onboarding/onboardingDashboard/onboardingAccessGate";
import MaintainAccessGate from "../../../components/charitySetup/onboarding/onboardingDashboard/maintainAccessGate";

const OnboardingCustomationLayoutContainer = () => {
  const [searchParams] = useSearchParams();
  const fromHub = searchParams.get("from") === "hub";
  const AccessGate = fromHub ? MaintainAccessGate : OnboardingAccessGate;

  return (
    <ProtectedRoute>
      <AccessGate>
        <main>
          <LayoutStyles>
            <OnboardingCustomationLayout />
          </LayoutStyles>
        </main>
      </AccessGate>
    </ProtectedRoute>
  );
};

export default OnboardingCustomationLayoutContainer;
